import React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cva } from 'class-variance-authority';
import { cn } from 'src/lib/utils';

const indicatorVariants = cva('h-full w-full flex-1 rounded-full transition-transform duration-500 ease-out', {
  variants: {
    scope: {
      default: 'bg-primary',
      scope1: 'bg-gradient-to-r from-foreground to-accent',
      scope2: 'bg-gradient-to-r from-[#3D6B57] to-primary',
      scope3: 'bg-gradient-to-r from-primary to-[#8BB89A]',
      amber: 'bg-gradient-to-r from-secondary to-[#E8B96A]',
      danger: 'bg-gradient-to-r from-destructive to-[#e74c3c]',
    },
  },
  defaultVariants: {
    scope: 'default',
  },
});

const Progress = React.forwardRef(function Progress({ className, value, scope, ...props }, ref) {
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn('relative h-2.5 w-full overflow-hidden rounded-full bg-muted', className)}
      value={value}
      {...props}>
      <ProgressPrimitive.Indicator
        className={indicatorVariants({ scope })}
        style={value != null ? { transform: `translateX(-${100 - (value || 0)}%)` } : undefined}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
